<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/procurement-management/rfqs"></back-button>
          Add RFQ
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`procurement-management/rfqs`">RFQs</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="rfq-tab"
                  data-bs-toggle="tab"
                  href="#rfq"
                  role="tab"
                  aria-controls="rfq"
                  aria-selected="true"
                  >RFQ</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="rfqDetail-tab"
                  data-bs-toggle="tab"
                  href="#rfqDetail"
                  role="tab"
                  aria-controls="rfqDetail"
                  aria-selected="false"
                  >RFQ Details</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="rfqSupplier-tab"
                  data-bs-toggle="tab"
                  href="#rfqSupplier"
                  role="tab"
                  aria-controls="rfqSupplier"
                  aria-selected="false"
                  >RFQ Supplier</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For RFQ -->
              <div
                class="tab-pane fade show active"
                id="rfq"
                role="tabpanel"
                aria-labelledby="rfq-tab"
              >
                <h4>RFQ</h4>
                <hr />
                <rfq-form :form="form"></rfq-form>
              </div>
              <!-- For RFQ Detail -->
              <div
                class="tab-pane fade"
                id="rfqDetail"
                role="tabpanel"
                aria-labelledby="rfqDetail-tab"
              >
                <h4>RFQ Details</h4>
                <hr />
                <rfq-details-form :form="form"></rfq-details-form>
              </div>
              <!-- For RFQ Suppliers -->
              <div
                class="tab-pane fade"
                id="rfqSupplier"
                role="tabpanel"
                aria-labelledby="rfqSupplier-tab"
              >
                <rfq-supplier-form :form="form"></rfq-supplier-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import RfqDetailsForm from "./rfq-details-form.vue";
import RfqForm from "./rfq-form.vue";
import RfqSupplierForm from "./rfq-supplier-form.vue";

export default {
  components: { RfqDetailsForm, RfqForm, RfqSupplierForm },
  name: "CrewCreate",
  data() {
    return {
      form: {
        requisition_id: "",
        rfq_details: [
          {
            spare_part_id: "",
          },
        ],
        rfq_suppliers: [
          {
            supplier_id: "",
          },
        ],
      },

      isLoading: false,
    };
  },

  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.crew = await axios.post("/rfqs", this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/rfqs");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
